var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 750.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365,103.9,278.24,250.72l206,348.64-31,52.5L247.2,303.22,122.8,513.82H313.51L453.15,750.28l89.16-150.92-206-348.68L365,202.24l206,348.68L600,501.71ZM210.31,464l36.89-62.45L284.08,464Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.09 513.8 332.59 49.14 303.55 0 0 513.8 58.09 513.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpBack);
export default __webpack_public_path__ + "static/media/signUpBack.ba0fdc3227c4dcfb3ea75781bce072b2.svg";
export { ForwardRef as ReactComponent };